import { ViewLayoutPlacement } from "@faire/web-api/indigofair/data/ViewLayoutPlacement";
import * as React from "react";
import { useLayoutEffect } from "react";

import { SDUIRenderer } from "@faire/retailer/components/SDUI/SDUIRenderer";
import {
  ComponentRenderMap,
  SectionRenderMap,
} from "@faire/retailer/components/SDUI/types";
import { PageInitialized } from "@faire/retailer/events";
import { useBrowseV3LayoutQuery } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/v3/useBrowseV3LayoutQuery";
import { useIsHubCategory } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useIsHubCategory";
import { LoggedInCategoryPageLoadingSkeleton } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/CategoryPageLoadingSkeleton/LoggedInCategoryPageLoadingSkeleton";

// TODO (FD-231882): implement hardcoded UPLT on appropriate SDUI renderer section
export const SDUICategoryPageContentsV2: React.FC<{
  componentRenderers: ComponentRenderMap;
  sectionRenderers: SectionRenderMap;
}> = ({ componentRenderers, sectionRenderers }) => {
  const { data: topViewLayout, isFetching: isTopLayoutLoading } =
    useBrowseV3LayoutQuery(ViewLayoutPlacement.TOP);

  const { data: fpsViewLayout, isFetching: isFPSLayoutLoading } =
    useBrowseV3LayoutQuery(ViewLayoutPlacement.FPS);

  const isHubCategory = useIsHubCategory();

  useLayoutEffect(() => {
    if (isHubCategory && !isTopLayoutLoading) {
      PageInitialized.publish();
    } else if (!isHubCategory && !isFPSLayoutLoading) {
      PageInitialized.publish();
    }
  }, [isHubCategory, isTopLayoutLoading, isFPSLayoutLoading]);

  return (
    <>
      {isTopLayoutLoading || topViewLayout === undefined ? null : (
        <SDUIRenderer
          viewLayout={topViewLayout}
          componentRenderers={componentRenderers}
          sectionRenderers={sectionRenderers}
          UPLTprops={{
            shouldRenderBelowTheFold: false,
          }}
        />
      )}
      {isFPSLayoutLoading || fpsViewLayout === undefined ? (
        <LoggedInCategoryPageLoadingSkeleton />
      ) : (
        <SDUIRenderer
          viewLayout={fpsViewLayout}
          componentRenderers={componentRenderers}
          sectionRenderers={sectionRenderers}
          UPLTprops={{
            shouldRenderBelowTheFold: false,
          }}
        />
      )}
    </>
  );
};
